<div
	class="form-group"
	[formGroup]="OBJ_form_group">
	<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
		<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
		   [tooltip]="tooltipTemplate"
		   placement="top"
		   triggers="click"
		   containerClass="tig-tooltip"
		   delay="50"></i></label>
	<div class="col-lg-8">
		<table class="table table-bordered">
			<thead>
			<tr>
				<th *ngFor="let STR_key of objectKeys(OBJ_field_config.value[0])">{{STR_key|translate}}</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let OBJ_entry of OBJ_field_config.value">
				<td *ngFor="let STR_key of objectKeys(OBJ_entry)">{{OBJ_entry[STR_key] | json}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</div>
